// utils/getImages.js
function importAll(r) {
  let images = {};
  r.keys().forEach((item) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}

// Importa todas las imágenes de la carpeta soluciones-industria
const imagesSolInd = importAll(
  require.context("../assets/soluciones-industria", false, /\.(png|jpe?g|svg|webp)$/)
);

// Función que busca una imagen por nombre de archivo
export const getImageSolInd = (name) => imagesSolInd[name];



